import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const SetSpotlightsEnabledInputSchema = z.object({
  teamId: zExt.objectId(),
  enabled: z.boolean(),
});

export const SetSpotlightsEnabledOutputSchema = z.object({});

export type SetSpotlightsEnabledInput = z.infer<
  typeof SetSpotlightsEnabledInputSchema
>;
export type SetSpotlightsEnabledOutput = z.infer<
  typeof SetSpotlightsEnabledOutputSchema
>;

export const setSpotlightsEnabled = {
  name: "setSpotlightsEnabled" as const,
  input: SetSpotlightsEnabledInputSchema,
  output: SetSpotlightsEnabledOutputSchema,
};
